/* tslint:disable */
import {
  Classroom,
  UserAccount
} from '../index';

declare var Object: any;
export interface ClassroomStudentInterface {
  "classroomId": number;
  "userAccountId": number;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
  classroom?: Classroom;
  student?: UserAccount;
}

export class ClassroomStudent implements ClassroomStudentInterface {
  "classroomId": number;
  "userAccountId": number;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  classroom: Classroom;
  student: UserAccount;
  constructor(data?: ClassroomStudentInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ClassroomStudent`.
   */
  public static getModelName() {
    return "ClassroomStudent";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ClassroomStudent for dynamic purposes.
  **/
  public static factory(data: ClassroomStudentInterface): ClassroomStudent{
    return new ClassroomStudent(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ClassroomStudent',
      plural: 'ClassroomStudents',
      path: 'ClassroomStudents',
      idName: 'id',
      properties: {
        "classroomId": {
          name: 'classroomId',
          type: 'number'
        },
        "userAccountId": {
          name: 'userAccountId',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        classroom: {
          name: 'classroom',
          type: 'Classroom',
          model: 'Classroom',
          relationType: 'belongsTo',
                  keyFrom: 'classroomId',
          keyTo: 'id'
        },
        student: {
          name: 'student',
          type: 'UserAccount',
          model: 'UserAccount',
          relationType: 'belongsTo',
                  keyFrom: 'userAccountId',
          keyTo: 'id'
        },
      }
    }
  }
}
